// En InventarioDetails.jsx
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db }  from "../../services/firebase";
import { ReactComponent as InventarioIcon } from '../../assets/icons/InventarioIcon.svg'
import LoadingSpinner from '../LoadingSpinner';
const getAbbreviation = (unit) => {
  const safeUnit = unit || "Unidad";
  const abbreviations = {
    Unidad: "u",
    Kilos: "kg",
    Gramos: "gr",
    Litro: "lts",
    Centilitros: "cl",
    Mililitros: "ml",
  };
  return abbreviations[safeUnit] || safeUnit;
};
const InventarioDetails = () => {
  const { id } = useParams();
  const [documento, setDocumento] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocumento = async () => {
      try {
        const docRef = doc(db, 'inventario', id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setDocumento(docSnap.data());
        } else {
          console.log("No se encontró el documento!");
        }
      } catch (error) {
        console.error("Error al obtener el documento:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDocumento();
  }, [id]);

const formatearFecha = (timestamp) => {
  if (!timestamp) return "-";
  const date = timestamp.toDate();
  const dia = String(date.getDate()).padStart(2, '0');
  const mes = String(date.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
  const anio = date.getFullYear();
  return `${dia}/${mes}/${anio}`;
};


const formatearModificacion = (timestamp) => {
    if (!timestamp) return '-';

    let dateObj;
    if (timestamp.toDate) {
        // Timestamp de Firebase Firestore
        dateObj = timestamp.toDate();
    } else if (timestamp.seconds) {
        // Timestamp tipo object con seconds
        dateObj = new Date(timestamp.seconds * 1000);
    } else {
        return '-';
    }

    const dia = String(dateObj.getDate()).padStart(2, '0');
    const mes = String(dateObj.getMonth() + 1).padStart(2, '0');
    const anio = dateObj.getFullYear();
    const horas = String(dateObj.getHours()).padStart(2, '0');
    const minutos = String(dateObj.getMinutes()).padStart(2, '0');

    return `El ${dia}/${mes}/${anio} a las ${horas}:${minutos}`;
};


  if (loading) {
    return <LoadingSpinner/>
  }

  if (!documento) {
    return <p>Documento no encontrado.</p>;
  }

  return (
    <div className="doc-detail viticultura-detail">
                    <header className="trazabilidad-header">
                <div className="header-content">
                    <h1>Inventario</h1>
                </div>
            </header>
<div className="doc-detail header" style={{ display: 'flex', gap: '40px' }}>
    {/* Columna 1: ID */}
    <div className="header-column" style={{ flex: 1,flexDirection: 'row',gap: '10px', justifyContent: 'left', alignItems:'center' }}>
        <div className="doc-icon-container">
        <InventarioIcon className="doc-icon" style={{ width:'20px',  margin:'auto'}}/>
        </div>
        <p className="header-value" style={{fontSize: '22px', color: '#2c2c2c'}}>{formatearFecha(documento.fecha)}</p>
    </div>

    {/* Columna 2: Creado por */}
    <div className="header-column" style={{ flex: 1 }}>
        <label className="header-label">Creado por</label>
        <p className="header-value">{documento.modificador || '-'}</p>
        <p className="header-value">{formatearModificacion(documento.fecha)}</p>
    </div>

    {/* Columna 3: Última modificación */}
    <div className="header-column" style={{ flex: 1 }}>
    </div>

    </div>
    {documento.cambios && documento.cambios.length > 0 ? (
      <div className="table-container inventarioDetails-table-container">
        <table className="table-full inventarioDetails-table">
          <thead className="inventarioDetails-thead">
            <tr className="inventarioDetails-tr-head">
              <th className="inventarioDetails-th">Categoría</th>
              <th className="inventarioDetails-th">Nombre</th>
              <th className="inventarioDetails-th">Unidades existentes</th>
              <th className="inventarioDetails-th">Conteo</th>
              <th className="inventarioDetails-th">Diferencia</th>
              <th className="inventarioDetails-th">Motivo</th>
            </tr>
          </thead>
          <tbody className="inventarioDetails-tbody">
            {documento.cambios.map((cambio, index) => (
              <tr key={index} className="inventarioDetails-tr-body">
                <td className="inventarioDetails-td">{cambio.categoria || '-'}</td>
                <td className="inventarioDetails-td">{cambio.nombre || '-'}</td>
                <td className="inventarioDetails-td">
                  {cambio.cantidadUnidades !== undefined ? `${cambio.cantidadUnidades} ${getAbbreviation(cambio.tipoUnidad)}` : '-'}
                </td>
                <td className="inventarioDetails-td">
                  {cambio.conteo !== undefined ? `${cambio.conteo} ${getAbbreviation(cambio.tipoUnidad)}` : '-'}
                </td>
<td
  className="inventarioDetails-td"
  style={{
    color: cambio.diferencia === 0 ? '#39b54a' : '#e65c5c',
  }}
>
  {
    cambio.diferencia !== undefined
      ? `${
          cambio.diferencia < 0
            ? `(${Math.abs(cambio.diferencia)})` // Paréntesis para números negativos
            : cambio.diferencia === 0
            ? cambio.diferencia // Sin paréntesis para 0
            : cambio.diferencia // Sin paréntesis para números positivos
        } ${getAbbreviation(cambio.tipoUnidad)}`
      : '-'
  }
</td>
                <td className="inventarioDetails-td" style={{ textTransform: 'capitalize' }}>{cambio.motivo || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <p>Este documento no tiene cambios registrados.</p>
    )}</div>
  );
};

export default InventarioDetails;